import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../../components/gmaps";
import { toast } from "react-toastify";

const PurchaseInvoiceForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [taxs, setTaxs] = useState();
  const [currancys, setCurrancys] = useState();
  const [products, setProducts] = useState();
  const [units, setUnits] = useState();

  const [discountPr, setDiscountPr] = useState(0);
  const [discountAmount, setdiscountAmount] = useState(0);

  const [totalAmount, setTotalAmount] = useState(0);
  const [costInWords, setCostInWords] = useState("");
  const [taxId, setTaxId] = useState("");
  const [currencyId, setCurrencyId] = useState("");
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [goodRecipetData, setGoodRecieptData] = useState([]);
  const [goodRecipetId, setGoodRecieptId] = useState(0);
  const [purchaseData, setPurchaseData] = useState([]);
  const [vendorId, setVendorId] = useState(0);

  const [selectedId, setSelectedId] = useState([]);

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [purchaseInvoiceId, setPurchaseInvoiceId] = useState(false);
  const [docurl, setDocUrl] = useState(false);
  const [subTotalAmount, setSubTotal] = useState(0);

  const [billinglatLong, setBillinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });
  const [billingclose, setBillingclose] = useState(false);
  const [shippinglatLong, setShippinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });
  const [shippingclose, setShippingclose] = useState(false);
  const [loading, setLoading] = useState(false);

  
  const { sendRequest: postPurchaseInvoice } = useHttp();

  const { sendRequest: getGoodRecieptData } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getLoadVendor } = useHttp();

  const loadVendorData = (id) => {
    getLoadVendor(
      {
        url: `/api/addVendor/?vendorId=${id}`,
      },
      (res) => {
        // //console.log(res);
        if (res) {
          // frmRef.current.vendor_id.value = res.vendorId;
          // frmRef.current.vendor_name.value = res.vendorName || "";
          frmRef.current.contact_person_name.value =
            res.contactPersonName || "";
          frmRef.current.work_contact.value = res.contactWork || "";
          frmRef.current.whatsapp_contact.value = res.whatsapp || "";
          frmRef.current.email.value = res.email || "";
          //// //console.log(productDetails);
        }
      }
    );
  };

  const { sendRequest: getPurchaseorderId } = useHttp();

  useEffect(() => {
    getPurchaseorderId(
      {
        url: `/api/purchaseOrder/?orgId=${localStorage.getItem(
          "orgId"
        )}&invoice=${true}`,
      },
      (res) => {
        if (res) {
          setPurchaseData(res.output);
        }
      }
    );
  }, [getPurchaseorderId]);

  useEffect(() => {
    if (selectedId != 0) {
      getGoodRecieptData(
        {
          url: `/api/goodsReciept/?orgId=${localStorage.getItem(
            "orgId"
          )} &purchaseOrderId=${selectedId}&invoice=${true}`,
        },
        (res) => {
          if (res) {
            console.log(res);

            const datas = res;

            setGoodRecieptData(datas);
          }
        }
      );

      getPurchaseorderId(
        {
          url: `/api/purchaseOrder/?orgId=${localStorage.getItem(
            "orgId"
          )}&purchaseOrderId=${selectedId}`,
        },
        (res) => {
          // //console.log(res);

          if (res) {
            frmRef.current.vendor_name.value = res.vendorName;

            setVendorId(res.vendorId);
            loadVendorData(res.vendorId);
            frmRef.current.shipp_address.value = res.shippingAddress;
            frmRef.current.shipp_city.value = res.shippingCity;
            frmRef.current.shipp_state.value = res.shippingState;
            frmRef.current.shipp_zopcode.value = res.shippingZip;
            frmRef.current.Shipp_country.value = res.shippingCountry;

            frmRef.current.terms.value = res.terms;
            frmRef.current.bill_address.value = res.billingAddress;
            frmRef.current.bill_city.value = res.billingCity;
            frmRef.current.bill_state.value = res.billingState;
            frmRef.current.bill_zipcode.value = res.billingZip;
            frmRef.current.bill_country.value = res.billingCountry;
            frmRef.current.bill_lat_long.value = res.billinglatLong;

            frmRef.current.contact_person_name.value = res.contactPersonName;
            frmRef.current.purchase_order_id.value = res.purchaseorderId;

            setBillinglatLong(res.billinglatLong);
            setShippinglatLong(res.shippinglatLong);
            frmRef.current.address_check.checked =
              res.is_shippingSameBillingAdd;
          }
        }
      );
    } else {
      setGoodRecieptData([]);
      frmRef.current.vendor_name.value = "";
      //frmRef.current.vendor_id.value = res.vendorId;

      frmRef.current.shipp_address.value = "";
      frmRef.current.shipp_city.value = "";
      frmRef.current.shipp_state.value = "";
      frmRef.current.shipp_zopcode.value = "";
      frmRef.current.Shipp_country.value = "";

      frmRef.current.terms.value = "";
      frmRef.current.bill_address.value = "";
      frmRef.current.bill_city.value = "";
      frmRef.current.bill_state.value = "";
      frmRef.current.bill_zipcode.value = "";
      frmRef.current.bill_country.value = "";

      frmRef.current.contact_person_name.value = "";

      frmRef.current.work_contact.value = "";
      frmRef.current.whatsapp_contact.value = "";
      frmRef.current.email.value = "";
    }
  }, [selectedId]);

  function setAddr() {
    frmRef.current.shipp_address.value = frmRef.current.bill_address.value;
    frmRef.current.shipp_city.value = frmRef.current.bill_city.value;
    frmRef.current.shipp_state.value = frmRef.current.bill_state.value;
    frmRef.current.shipp_zopcode.value = frmRef.current.bill_zipcode.value;
    frmRef.current.Shipp_country.value = frmRef.current.bill_country.value;
  }
  function clearAddr() {
    frmRef.current.shipp_address.value = "";
    frmRef.current.shipp_city.value = "";
    frmRef.current.shipp_state.value = "";
    frmRef.current.shipp_zopcode.value = "";
    frmRef.current.Shipp_country.value = "";
  }

  const onChange = (e) => {
    //  //console.log(`checked = ${e.target.checked}`);
    const flag = e.target.checked || false;

    if (flag == true) {
      setAddr();
    } else {
      clearAddr();
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (productDetails.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }

    setLoading(true);

    const data = {
      purchaseInvoiceDate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      goodsReceiptId: frmRef.current.goods_receipt_id.value,
      purchaseOrderId: frmRef.current.purchase_order_id.value,
      supervisorEmployeeId: employeeId,
      vendorId: vendorId,

      currencyId: currencyId,
      productDetails: productDetails,

      lineTotalAmount: subTotalAmount,

      discountPercentage: discountPr,
      discountAmount: discountAmount,
      totalAmount: totalAmount,
      frieghtCharges: frmRef.current.frieght_charges.value,

      taxId: taxId,
      taxAmount: parseFloat(frmRef.current.tax_amt.value).toFixed(2),
      totalPurchaseAmount: parseFloat(frmRef.current.total_cost.value).toFixed(
        2
      ),
      amountChargeable: frmRef.current.amt_chargeable.value,
      billinglatLong,
      shippinglatLong,
      status: 1,
      remark: frmRef.current.remark.value,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };

    if (props.update) {
      data["purchaseInvoiceId"] = props.update.purchaseInvoiceId;
    }
    postPurchaseInvoice(
      {
        url: "/api/purchaseInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(
          `Purchase invoice detail ${props.update ? "Updated" : "Added"}`
        );
        setPurchaseInvoiceId(res.purchaseInvoiceId);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
       
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  const { sendRequest: getInvoiceProduct } = useHttp();

  useEffect(
    (e) => {
      //  e.preventDefault();

      console.log(props.update);
      loadVendorData(props.update.vendorId);
      setProductDetails(props.update.productDetails);

      if (props.update) {
        frmRef.current.date.value = props.update.purchaseInvoiceDate;
        setSelectedId(props.update.purchaseOrderId);
        setGoodRecieptId(props.update.goodsReceiptId);

        setEmployeeId(props.update.supervisorEmployeeId);

        setSubTotal(props.update.lineTotalAmount);
        setDiscountPr(props.update.discountPercentage);

        setCostInWords(props.update.amountChargeable);
        setTotalAmount(props.update.totalAmount);
        setdiscountAmount(props.update.discountAmount);
        setTaxId(props.update.taxId);
        setCurrencyId(props.update.currencyId);

        frmRef.current.tax.value = props.update.taxPercentage;

        frmRef.current.tax_amt.value = props.update.taxAmount;
        frmRef.current.currency.value = props.update.currencyName;
        frmRef.current.discountAmount = props.update.discountAmount;
        frmRef.current.total_cost.value = props.update.totalPurchaseAmount;
        frmRef.current.amt_chargeable.value = props.update.amountChargeable;
        frmRef.current.remark.value = props.update.remark;
        frmRef.current.terms.value = props.update.terms;
        frmRef.current.frieght_charges.value = props.update.frieghtCharges;

        getInvoiceProduct(
          {
            url: `/api/PurchaseInvoiceProduct/?orgId=${localStorage.getItem(
              "orgId"
            )}&purchaseInvoiceId=${props.update.purchaseOrderId}`,
          },
          (res) => {
            setProductDetails(res.output);
          }
        );
      }
    },
    [props.update]
  );

  const loadReciptData = (e) => {
    getGoodRecieptData(
      {
        url: `/api/GoodsReceiptProductForPI/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodsReceiptId=${goodRecipetId}`,
      },
      (res) => {
        var goodRecipet = goodRecipetData && goodRecipetData[0];

        setProductDetails(res.output);

        setSubTotal(goodRecipet.lineTotalAmount);
        setDiscountPr(goodRecipet.discountPercentage);

        frmRef.current.total_amt.value =
          res.lineTotalAmount - goodRecipet.discountAmount;
        frmRef.current.frieght_charges.value = goodRecipet.freightCharges;
        frmRef.current.tax.value = goodRecipet.taxPercentage;
        setTaxId(goodRecipet.taxId);
        setCurrencyId(goodRecipet.currencyId);
        frmRef.current.currency.value = goodRecipet.currencyName;
        setdiscountAmount(goodRecipet.discountAmount);

        frmRef.current.tax_amt.value = goodRecipet.taxAmount;
        frmRef.current.total_cost.value = goodRecipet.totalPurchaseAmount;

        frmRef.current.remark.value = goodRecipet.remark;
        setCostInWords(goodRecipet.amountChargeable);
        setTotalAmount(goodRecipet.totalAmount);

        // props.addForm(false);
      }
    );
  };

  const viewPdf = (e) => {
    e.preventDefault();
    setDocUrl(true);
  };

  const handleBillingLatLong = () => {
    setBillingclose(true);
  };
  const handleShippingLatLong = () => {
    setShippingclose(true);
  };

  useEffect(() => {
    loadReciptData();
  }, [goodRecipetId]);

  return (
    <>
      {billingclose && (
        <Modal onClose={setBillingclose} isOpen={true} style={modalStyles}>
          <div className="text-center">
            <SimpleMap
              lat={billinglatLong.lat}
              lng={billinglatLong.lng}
              set={setBillinglatLong}
              close={setBillingclose}
              className="text-center"
            />
          </div>
        </Modal>
      )}
      {shippingclose && (
        <Modal onClose={setShippingclose} isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={shippinglatLong.lat}
            lng={shippinglatLong.lng}
            set={setShippinglatLong}
            close={setShippingclose}
          />
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="">
            <table className="table table-bordered table-responsive">
              <thead>
                <tr className="">
                  <th>Sr.No</th>
                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Type</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.linesrNo}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.goodsReceiptQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.rate * itm.goodsReceiptQuantity}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <hr />
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"subTotalAmount"}>Sub-total Amount</label>
              <input
                type={"number"}
                id={"subTotalAmount"}
                value={subTotalAmount}
                ref={(el) => (productRef.current["subTotalAmount"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discount"}>Discount(%)</label>
              <input
                type={"number"}
                id={"discount"}
                required
                value={discountPr}
                ref={(el) => (productRef.current["discount"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discountAmount"}>Discount Amount</label>
              <input
                type={"number"}
                id={"discountAmount"}
                required
                disabledd
                value={discountAmount}
                ref={(el) => (productRef.current["discountAmount"] = el)}
                className="form-control"
                disabled
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"totalAmount"}>Total Amount</label>
              <input
                type={"input"}
                id={"totalAmount"}
                required
                value={totalAmount}
                disabledd
                ref={(el) => (productRef.current["totalAmount"] = el)}
                className="form-control"
                disabled
              />
            </div>
          </div>
          <div className="text-center mt-5">
            {" "}
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails &&
                  productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Purchase Invoice Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}>
                        {" "}
                        {"Assign Employee"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option value="">select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"purchase_order_id"}>
                        {"Purchase Order No"}
                      </label>
                      <select
                        id="purchase_order_id"
                        required
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["purchase_order_id"] = el)}
                        value={selectedId}
                        onChange={(e) => setSelectedId(e.target.value)}
                      >
                        <option value="">select</option>
                        {purchaseData &&
                          purchaseData.map((x, i) => (
                            <option key={i} value={x.purchaseOrderId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"goods_receipt_id"}>
                        {"Goods Receipt No"}
                      </label>

                      <select
                        id="goods_receipt_id"
                        required
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["goods_receipt_id"] = el)}
                        value={goodRecipetId}
                        onChange={(e) => setGoodRecieptId(e.target.value)}
                      >
                        <option value="">select</option>
                        {goodRecipetData &&
                          goodRecipetData.map((x, i) => (
                            <option key={i} value={x.goodsReceiptId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}> {"Vendor Name"}</label>
                      <input
                        id="vendor_name"
                        type={"text"}
                        disabled
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        required
                        ref={(el) => (frmRef.current["whatsapp_contact"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"terms"}>{"Terms(if Any)"}</label>
                      <input
                        type={"text"}
                        id={"terms"}
                        ref={(el) => (frmRef.current["terms"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_address"}>
                        {" "}
                        {"Billing Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_address"}
                        required
                        ref={(el) => (frmRef.current["bill_address"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"bill_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"bill_city"}
                        required
                        ref={(el) => (frmRef.current["bill_city"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"bill_state"}>
                        {" "}
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_state"}
                        required
                        ref={(el) => (frmRef.current["bill_state"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Zip Code (Postal Code)"}>
                        {" "}
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_zipcode"}
                        required
                        ref={(el) => (frmRef.current["bill_zipcode"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"bill_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"bill_country"}
                        required
                        ref={(el) => (frmRef.current["bill_country"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="form-check ">
                      <input
                        type={"checkbox"}
                        id={"same_address"}
                        ref={(el) => (frmRef.current["same_address"] = el)}
                        className="form-check-input"
                        onClick={onChange}
                      />
                      <label
                        htmlFor={"same_address"}
                        className="form-check-label"
                      >
                        {"Shipping Address same as  Billing Address"}
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Shipping Address"}>
                        {" "}
                        {"Shipping Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_address"}
                        required
                        ref={(el) => (frmRef.current["shipp_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"shipp_city"}
                        required
                        ref={(el) => (frmRef.current["shipp_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_state"}>
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_state"}
                        required
                        ref={(el) => (frmRef.current["shipp_state"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_zopcode"}>
                        {" "}
                        {" Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_zopcode"}
                        required
                        ref={(el) => (frmRef.current["shipp_zopcode"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Shipp_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"Shipp_country"}
                        required
                        ref={(el) => (frmRef.current["Shipp_country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          // //console.log(productDetails);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.goodsReceiptDetailId
                              )
                            );
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        View
                      </button>
                    </div>{" "}
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        value={totalAmount}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}> {"Currency"}</label>

                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        required
                        ref={(el) => (frmRef.current["currency"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax(%)"}</label>

                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        ref={(el) => (frmRef.current["tax"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>

                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        ref={(el) => (frmRef.current["frieght_charges"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        value={costInWords}
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PurchaseInvoiceForm;
